import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useApi } from "../lib/settings";

const COLORS = ["#fc0", "#ff5a5f", "#6dd829", "#35e3e2", "#ff9f1c", "#FFADD9"];

export function Logo() {
  return (
    <Link to="/" className="gg-logo" data-testid="header-logo" aria-label="Giochi.Gratis - Home">
      <span className="gg-l1">
        {"GIOCHI".split("").map((c, i) => (
          <b key={i} style={{ color: COLORS[i] }}>{c}</b>
        ))}
      </span>
      <span className="gg-l2">.GRATIS</span>
    </Link>
  );
}

const ITEMS = [
  { to: "/nuovi-giochi", icon: "fa-bolt", label: "Nuovi", tip: "Nuovi Giochi", id: "new" },
  { to: "/migliori-giochi", icon: "fa-crown", label: "Migliori", tip: "Giochi Migliori", id: "best" },
  { to: "/giochi-in-evidenza", icon: "fa-star", label: "In evidenza", tip: "Giochi in Evidenza", id: "featured" },
  { to: "/giocati", icon: "fa-clock-rotate-left", label: "Giocati", tip: "Giochi Giocati", id: "played" },
  { to: "/preferiti", icon: "fa-heart", label: "Preferiti", tip: "I tuoi Preferiti", id: "favorites" },
];

function SearchForm({ onDone, testid }) {
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    nav(`/cerca?q=${encodeURIComponent(q.trim())}`);
    setQ("");
    onDone && onDone();
  };
  return (
    <form className="search-form" onSubmit={submit} autoComplete="off">
      <input className="txt fn-left search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca giochi..." data-testid={`${testid}-input`} />
      <input type="submit" className="btn" value="VAI" data-testid={`${testid}-submit`} />
    </form>
  );
}

function Hover({ children, popup, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <li className={className} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      {children}
      {open && popup(() => setOpen(false))}
    </li>
  );
}

export function Header() {
  const cats = useApi("/categories", []);
  const [mobile, setMobile] = useState(false);
  const loc = useLocation();
  useEffect(() => {
    setMobile(false);
  }, [loc.pathname, loc.search]);
  const list = Array.isArray(cats.data) ? cats.data : [];
  return (
    <>
      <div id="header" className="fix-top" data-testid="site-header">
        <div className="head-inner fn-clear">
          <div className="logo"><Logo /></div>
          <div className="menu">
            <ul className="menu-ul fn-clear">
              <Hover
                className="submenu"
                popup={(close) => (
                  <div className="menupopup" onClick={close}>
                    <ul className="cate-list">
                      {list.slice(0, 15).map((c) => (
                        <li key={c.slug}>
                          <Link to={`/categoria/${c.slug}`} data-testid={`menu-cat-${c.slug}`}>
                            {c.name}<span>({c.total})</span>
                          </Link>
                        </li>
                      ))}
                      <li><Link to="/categorie">Altre categorie &gt;&gt;</Link></li>
                    </ul>
                  </div>
                )}
              >
                <Link to="/categorie" data-testid="nav-categories"><i className="fa-solid fa-gamepad" /><span>Categorie</span></Link>
              </Hover>
              {ITEMS.map((it) => (
                <Hover key={it.id} popup={() => (
                  <div className="tooltip featip"><span className="arrow" /><div className="tip-txt">{it.tip}</div></div>
                )}>
                  <Link className="tips" to={it.to} data-testid={`nav-${it.id}`}><i className={`fa-solid ${it.icon}`} /><span>{it.label}</span></Link>
                </Hover>
              ))}
              <Hover className="submenu" popup={(close) => (
                <div className="menupopup"><SearchForm onDone={close} testid="header-search" /></div>
              )}>
                <a href="#cerca" onClick={(e) => e.preventDefault()} data-testid="nav-search"><i className="fa-solid fa-magnifying-glass" /><span>Cerca</span></a>
              </Hover>
            </ul>
          </div>
          <button type="button" className="kizi-mobile-menu-toggle" aria-expanded={mobile} aria-label={mobile ? "Chiudi menu" : "Apri menu"} onClick={() => setMobile((m) => !m)} data-testid="mobile-menu-toggle">
            <i className={mobile ? "fa-solid fa-xmark" : "fa-solid fa-bars"} />
          </button>
        </div>
      </div>
      <nav className="kizi-mobile-menu" hidden={!mobile} data-testid="mobile-menu">
        <Link to="/categorie"><i className="fa-solid fa-gamepad" /><span>Categorie</span></Link>
        {ITEMS.map((it) => (
          <Link key={it.id} to={it.to} data-testid={`mobile-nav-${it.id}`}><i className={`fa-solid ${it.icon}`} /><span>{it.tip}</span></Link>
        ))}
        <div className="gg-msearch"><SearchForm testid="mobile-search" /></div>
      </nav>
      <div className="h-head" />
    </>
  );
}
